import SvgIcon from '@/components/SvgIcon'// svg component
import {
    Document, Plus, CircleCheckFilled, Avatar, Star, InfoFilled,
    Grid, CirclePlusFilled, CircleCloseFilled, Coin, MagicStick, Search,
    CaretBottom, OfficeBuilding, ArrowRight, FolderAdd, TrendCharts,
    View, TopRight, Tools, Brush, Close, Edit, Check, Files, UploadFilled,
    DeleteFilled, FolderChecked, FolderDelete, Connection, Finished,ArrowDown,
} from '@element-plus/icons'
export default {
    install: function (app) {
        // register globally
        app.component('svg-icon', SvgIcon)
        // debugger
        // const svg = import.meta.globEager('./svg/*.svg')
        // Object.values(svg).map((v) => v.default)
        // const req = require.context('./svg', false, /\.svg$/)
        // const requireAll = requireContext => requireContext.keys().map(requireContext)
        // requireAll(req)        

        //element plus icon
        app.component('document', Document)
        app.component('plus', Plus)
        app.component('circle-check-filled', CircleCheckFilled)
        app.component('avatar', Avatar)
        app.component('star', Star)
        app.component('info-filled', InfoFilled)
        app.component('grid', Grid)
        app.component('circle-plus-filled', CirclePlusFilled)
        app.component('circle-close-filled', CircleCloseFilled)
        app.component('coin', Coin)
        app.component('magic-stick', MagicStick)
        app.component('search', Search)
        app.component('caret-bottom', CaretBottom)
        app.component('office-building', OfficeBuilding)
        app.component('ArrowRight', ArrowRight)
        app.component('FolderAdd', FolderAdd)
        app.component('trend-charts', TrendCharts)
        app.component('view-icon', View)
        app.component('top-right', TopRight)
        app.component('tools', Tools)
        app.component('brush', Brush)
        app.component('close', Close)
        app.component('edit', Edit)
        app.component('check', Check)
        app.component('files', Files)
        app.component('upload-filled', UploadFilled)
        app.component('delete-filled', DeleteFilled)
        app.component('folder-checked', FolderChecked)
        app.component('folder-delete', FolderDelete)
        app.component('connection', Connection)
        app.component('finished', Finished)
        app.component('arrow-down', ArrowDown)
    }
}